import { Divider, Flex, Modal, Tooltip } from "antd";
import "./UserInfo.scss";
import moment from "moment";

const UserInfo = ({ open, onClose, userDetails }) => {

  const teamLeads = userDetails?.team_lead_names || [];
  const firstTwoTeamLeads = teamLeads.slice(0, 2).join(', ');
  const restTeamLeads = teamLeads.slice(2).join(', ');

  const areacodes = userDetails?.operational_area?.map(area => area.areacode) || [];
  const firstTwo = areacodes.slice(0, 2).join(', ');
  const rest = areacodes.slice(2).join(', ');

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable
      destroyOnClose
      className="viewDetailsModal"
    >
      <h2 className="main-heading">All Details</h2>
      <Flex className="description-box" vertical>
        <Flex className="headline" orientation="left">
          Personal Information
        </Flex>
        <div className="detailsSection">
          <div className="detailRow">
            <span className="label">Name</span>
            <span className="value">{userDetails?.full_name}</span>
          </div>
          <div className="detailRow">
            <span className="label">Email</span>
            <span className="value">{userDetails?.email}</span>
          </div>
          <div className="detailRow">
            <span className="label">Phone</span>
            <span className="value">{userDetails?.mobile_no}</span>
          </div>
          <div className="detailRow">
            <span className="label">Role</span>
            <span className="value">{userDetails?.role}</span>
          </div>
          <div className="detailRow">
            <span className="label">Date of Joining</span>
            <span className="value">{moment(userDetails?.date_of_joining).format('DD-MM-YYYY')}</span>
          </div>
        </div>
      </Flex>

      <Flex className="description-box" vertical>
        <h2 className="headline">Field Activity</h2>
        <div className="detailsSection">
          <div className="detailRow">
            <span className="label">Assigned Team <span className="break"><br /></span> Lead</span>
            <span className="value">
              {firstTwoTeamLeads || "NA"}
              {teamLeads.length > 2 && (
                <>
                  ,&nbsp;
                  <Tooltip title={restTeamLeads}>
                    <span style={{ cursor: 'pointer' }}>
                      +{teamLeads.length - 2} more
                    </span>
                  </Tooltip>
                </>
              )}
            </span>

          </div>
          <div className="detailRow">
            <span className="label">Operational <span className="break"><br /></span> Zone</span>
            <span className="value">
              {firstTwo}
              {areacodes.length > 2 && (
                <>
                  ,&nbsp;
                  <Tooltip title={rest}>
                    <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                      +{areacodes.length - 2} more
                    </span>
                  </Tooltip>
                </>
              )}
            </span>
          </div>
          <div className="detailRow">
            <span className="label">Visits This <span className="break"><br /></span> Month</span>
            <span className="value">NA</span>
          </div>
          <div className="detailRow">
            <span className="label">Loan Cases <span className="break"><br /></span> Assigned</span>
            <span className="value">{userDetails?.cases_assigned}</span>
          </div>
          <div className="detailRow">
            <span className="label">Collection Success <span className="break"><br /></span> Rate</span>
            <span className="value">NA</span>
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default UserInfo;
